/**
 * Vocabulary: readers see this feature as "owner reviews"; code, routes, DealHunt paths and
 * analytics events keep the historical "owner note" name on purpose — do not rename them.
 *
 * The "1 / 3 ‹ ›" pager of an owner-note carousel — the reader's slides (`OwnerNoteSlides`) and
 * the review card (`review/ReviewOwnerCard`); `children` go in front (the guide row's dots, until
 * #217 made its reviews feed rows). The pager only scrolls a track every note is already in
 * (`useNoteCarousel`); each surface keeps its own slide markup (b01f16a8 Rejected: "share the
 * paging hook, not the markup") and passes its own classes — the round button is
 * `note-carousel.module.css` `.pagerBtn`, composed.
 */
interface NotePagerProps {
  active: number
  count: number
  goTo: (index: number) => void
  className: string
  countClassName: string
  buttonClassName: string
  /** Drawn before the counter (the guide row's dots). */
  children?: React.ReactNode
}

const NotePager: React.VFC<NotePagerProps> = ({
  active,
  count,
  goTo,
  className,
  countClassName,
  buttonClassName,
  children,
}) => (
  <div className={className}>
    {children}
    <span className={countClassName}>{`${active + 1} / ${count}`}</span>
    <button
      type="button"
      className={buttonClassName}
      aria-label="Previous owner review"
      disabled={active === 0}
      onClick={() => goTo(active - 1)}
    >
      {'‹'}
    </button>
    <button
      type="button"
      className={buttonClassName}
      aria-label="Next owner review"
      disabled={active === count - 1}
      onClick={() => goTo(active + 1)}
    >
      {'›'}
    </button>
  </div>
)

export default NotePager
